import * as React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';
import OverflowDetectorTooltip from 'common/components/core/tooltip/OverflowDetectorTooltip';
import theme from './MenuList.scss';

export const ListItemInnerComponent = ({
    item,
    theme,
    className,
    getTextRef
}) => {
    return (
        <div className={classnames(className, theme.listItemInner)}>
            <OverflowDetectorTooltip
                tooltip={item.label}
                className={theme.title}
            >
                <span className={theme.text} ref={getTextRef}>
                    {item.label}
                </span>
            </OverflowDetectorTooltip>
            {item.meta ? <div className={theme.meta}>{item.meta}</div> : null}
        </div>
    );
};

export const listItemFactory = ({ ListItemInner = ListItemInnerComponent }) => {
    class ListItemComponent extends React.Component {
        onClick = event => {
            this.props.onItemClick &&
                this.props.onItemClick(this.props.item, event);
        };
        onMouseEnter = event => {
            this.props.onItemMouseEnter &&
                this.props.onItemMouseEnter(this.props.item, event);
        };
        onMouseLeave = event => {
            this.props.onItemMouseLeave &&
                this.props.onItemMouseLeave(this.props.item, event);
        };
        render() {
            const {
                isSelected,
                isHovered,
                isDisabled,
                getTextRef,
                item,
                theme,
                ...others
            } = this.props;
            const { color } = item;

            return (
                <div
                    onClick={isDisabled ? null : this.onClick}
                    onMouseLeave={this.onMouseLeave}
                    onMouseEnter={this.onMouseEnter}
                    className={classnames(theme.listItem, {
                        [theme.selected]: isSelected,
                        [theme.hovered]: isHovered,
                        [theme.disabled]: isDisabled,
                        [theme[`listItem-${color}`]]: color
                    })}
                >
                    <ListItemInner
                        {...others}
                        item={item}
                        getTextRef={getTextRef}
                        theme={theme}
                    />
                </div>
            );
        }
    }
    return themr('List', theme)(ListItemComponent);
};

export const ListItemComponent = listItemFactory({});
